import {useStoreContext} from '@store/store-context';
import {useNavigate} from 'react-router-dom';
import {useSearchParams} from 'react-router-dom';

export const useViewInsight = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const {
    goalsState: {setInsightGoal},
    storeDashboardRoutes: {activateInsightTabs},
  } = useStoreContext();

  const viewGoalInsight = (
    goalId: string,
    isKpi?: boolean,
    tab: 'insight' | 'comment' | 'tasks' = 'insight',
    openStatusMenu = false,
  ) => {
    const dashboardBody = document.getElementById('dashboard-body');
    const dashboardScrollTop = dashboardBody?.scrollTop;

    setInsightGoal({
      goal: goalId,
      insight: true,
    });

    activateInsightTabs(tab);

    searchParams.set('goal', goalId);
    searchParams.set('insight', 'true');
    if (tab === 'comment') searchParams.set('comment', 'true');
    else searchParams.delete('comment');
    if (tab === 'tasks') searchParams.set('action-items', 'true');
    else searchParams.delete('action-items');
    if (isKpi) searchParams.set('isKpi', 'true');
    else searchParams.delete('isKpi');
    if (openStatusMenu) searchParams.set('status-review', 'true');
    else searchParams.delete('status-review');

    navigate({search: `?${searchParams.toString()}`});

    if (dashboardBody && dashboardScrollTop !== undefined) {
      const restoreScrollPosition = () => {
        dashboardBody.scrollTop = dashboardScrollTop;
      };
      restoreScrollPosition();
      window.requestAnimationFrame(restoreScrollPosition);
    }
  };

  return viewGoalInsight;
};
